import { useCallback, useState } from 'react';
import { Points } from 'shared/components/Points';
import { POINTS } from 'shared/constants/points';
import { TPoints } from 'shared/types/points';

export const PointsContainer: React.FC = () => {
  const [activePoint, setActivePoint] = useState(POINTS[0]);

  const handleActivePoint = useCallback((value: TPoints) => {
    setActivePoint(value);
  }, []);

  return <Points activePoint={activePoint} onActivePoint={handleActivePoint} />;
};
